import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const WebUrl = ShModel.extend({
  link: attr('string'),

  //timestamps
  createdAt: attr('date'),
  updatedAt: attr('date'),

  //Relationships
  pitch: belongsTo('pitch', { async: false }),
});

export default WebUrl;
